import { useEffect, useState } from "react";
import { Modal, Select, Checkbox, Alert } from "antd";
import { useSelector } from "react-redux";
import dayjsTZ from "../../../utils/dayjs";

// One modal for both overrides: hand a week to a person ("reassign") or
// exchange two weeks ("swap"), which is how an admin fixes a rotation by hand.
const ReassignModal = ({ open, mode, week, roster, weeks, saving, onCancel, onSubmit }) => {
  const { isDarkMode } = useSelector((state) => state.usersList);
  const [employeeId, setEmployeeId] = useState(null);
  const [withWeekStart, setWithWeekStart] = useState(null);
  const [notify, setNotify] = useState(false);

  useEffect(() => {
    setEmployeeId(week?.employeeId || null);
    setWithWeekStart(null);
    setNotify(false);
  }, [week, mode, open]);

  const weekLabel = week
    ? `${dayjsTZ(week.weekStart).format("DD/MM")} - ${dayjsTZ(week.weekEnd).format("DD/MM/YYYY")}`
    : "";

  const isSwap = mode === "swap";

  return (
    <Modal
      open={open}
      // The modal renders in a portal, so the page wrapper's `dark` class never
      // reaches it: it has to carry the theme classes itself.
      className={`aquamanReassignModal ${isDarkMode ? "dark darkHeader" : ""}`}
      title={isSwap ? `Ndërro javën ${weekLabel}` : `Cakto Aquaman për ${weekLabel}`}
      okText={isSwap ? "Ndërro" : "Ruaj"}
      cancelText="Anulo"
      confirmLoading={saving}
      okButtonProps={{ disabled: isSwap ? !withWeekStart : !employeeId }}
      onCancel={onCancel}
      onOk={() =>
        onSubmit(
          isSwap
            ? { weekStart: week.weekStart, action: "swap", withWeekStart }
            : { weekStart: week.weekStart, action: "reassign", employeeId, notify }
        )
      }
    >
      {isSwap ? (
        <Select
          style={{ width: "100%" }}
          placeholder="Zgjidh javën me të cilën ndërrohet"
          value={withWeekStart}
          onChange={setWithWeekStart}
          options={(weeks || [])
            .filter((w) => w.weekStart !== week?.weekStart)
            .map((w) => ({
              value: w.weekStart,
              label: `${dayjsTZ(w.weekStart).format("DD/MM")} - ${dayjsTZ(
                w.weekEnd
              ).format("DD/MM")} · ${w.employeeName || "pa caktuar"}`,
            }))}
        />
      ) : (
        <>
          <Select
            style={{ width: "100%" }}
            placeholder="Zgjidh punonjësin"
            value={employeeId}
            onChange={setEmployeeId}
            optionFilterProp="label"
            showSearch
            options={(roster?.participants || [])
              .filter((p) => p.active !== false)
              .map((p) => ({
                value: p.employeeId,
                label: `${p.employeeName} (${p.servedCount || 0} javë)`,
              }))}
          />
          <Checkbox
            style={{ marginTop: 12 }}
            checked={notify}
            onChange={(e) => setNotify(e.target.checked)}
          >
            Njofto menjëherë personin e caktuar
          </Checkbox>
        </>
      )}
      <Alert
        style={{ marginTop: 12 }}
        type="info"
        showIcon
        message="Java shënohet manuale, kështu që gjenerimi i radhës nuk e prek."
      />
    </Modal>
  );
};

export default ReassignModal;
